"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._SearchIcon = _SearchIcon;
exports.SearchIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _baseSvg = require("./base-svg");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _SearchIcon(props, ref) {
  return (/*#__PURE__*/_react.default.createElement(_baseSvg.BaseSVG, _extends({
      ref: ref
    }, props), function (fillColor) {
      return (/*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
          clipPath: "url(#clip0)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M15.6092 13.7273L12.5125 10.6307C13.4554 9.21923 13.8396 7.50755 13.5903 5.82856C13.341 4.14956 12.4762 2.62331 11.1639 1.54667C9.85167 0.470034 8.18586 -0.0800023 6.49052 0.00355119C4.79518 0.0871046 3.19153 0.798274 1.99151 1.99873C0.791479 3.19918 0.0808763 4.80308 -0.00207777 6.49845C-0.0850318 8.19381 0.465594 9.85943 1.54269 11.1713C2.61979 12.4832 4.14635 13.3475 5.82544 13.5962C7.50452 13.8448 9.21607 13.46 10.6272 12.5167L13.7238 15.6127C13.976 15.8586 14.3143 15.9963 14.6665 15.9963C15.0187 15.9963 15.357 15.8586 15.6092 15.6127C15.8591 15.3626 15.9995 15.0235 15.9995 14.67C15.9995 14.3164 15.8591 13.9774 15.6092 13.7273ZM6.83316 2.00333C7.7891 2.00333 8.72358 2.2868 9.51842 2.81789C10.3133 3.34898 10.9328 4.10385 11.2986 4.98702C11.6644 5.8702 11.7601 6.84202 11.5736 7.7796C11.3871 8.71717 10.9268 9.57839 10.2508 10.2543C9.57489 10.9303 8.71367 11.3906 7.7761 11.5771C6.83852 11.7636 5.8667 11.6679 4.98352 11.3021C4.10035 10.9363 3.34548 10.3168 2.81439 9.52192C2.2833 8.72708 1.99983 7.7926 1.99983 6.83666C2.00124 5.55521 2.51091 4.32666 3.41703 3.42054C4.32315 2.51442 5.55171 2.00474 6.83316 2.00333Z",
          fill: fillColor
        })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
          id: "clip0"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M0 0H16V16H0V0Z",
          fill: "white"
        }))))
      );
    })
  );
}

_SearchIcon.displayName = 'SearchIcon';

var SearchIcon = _react.default.forwardRef(_SearchIcon);

exports.SearchIcon = SearchIcon;
SearchIcon.defaultProps = _baseSvg.BaseSVG.defaultProps;
SearchIcon.propTypes = _baseSvg.BaseSVG.propTypes;
SearchIcon.displayName = 'SearchIcon';